import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/auth';
import Layout from './components/Layout';
import Login from './pages/Login';
import RegisterPasskey from './pages/RegisterPasskey';
import RegisterWithLink from './pages/RegisterWithLink';
import ResetPasskey from './pages/ResetPasskey';
import ResetPassword from './pages/ResetPassword';
import CreateUser from './pages/CreateUser';
import Dashboard from './pages/Dashboard';
import Tasks from './pages/Tasks';
import TaskDetail from './pages/TaskDetail';
import NewTask from './pages/NewTask';
import Groups from './pages/Groups';
import Reports from './pages/Reports';
import NewReport from './pages/NewReport';
import ReportDetail from './pages/ReportDetail';
import UserManagement from './pages/UserManagement';
import Profile from './pages/Profile';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<RegisterWithLink />} />
      <Route path="/register-passkey" element={<RegisterPasskey />} />
      <Route path="/reset-passkey" element={<ResetPasskey />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="tasks/new" element={<NewTask />} />
        <Route path="tasks/:id" element={<TaskDetail />} />
        <Route path="groups" element={<Groups />} />
        <Route path="reports" element={<Reports />} />
        <Route path="reports/new" element={<NewReport />} />
        <Route path="reports/:id" element={<ReportDetail />} />
        <Route path="admin/create-user" element={<CreateUser />} />
        <Route path="admin/users" element={<UserManagement />} />
        <Route path="profile" element={<Profile />} />
      </Route>
    </Routes>
  );
}

export default App;
